import type { RefAttributes } from "react";

import { mergeSx } from "@/common/helpers/mergeSx";
import { DashboardAutocomplete } from "@/dashboard-design-system/Autocomplete/DashboardAutocomplete";
import { AutocompleteOption, BaseAutocompleteProps } from "@/dashboard-design-system/Autocomplete/types";

type TableQuickFilterInputProps<Option extends AutocompleteOption<string>> = Omit<
  BaseAutocompleteProps<Option, true, false, false>,
  "ref"
> &
  RefAttributes<HTMLInputElement>;

export const TableQuickFilterInput = <Option extends AutocompleteOption<string>>({
  sx,
  ...props
}: TableQuickFilterInputProps<Option>) => (
  <DashboardAutocomplete
    {...props}
    size="small"
    sx={mergeSx(
      (theme) => ({
        "& .MuiInputBase-root": { minHeight: theme.spacing(4.5) },
        "& .MuiInputBase-input::placeholder": { color: theme.palette.text.neutral.quiet, opacity: 1 },
      }),
      sx
    )}
  />
);
